import { ReactNode, useEffect, useReducer } from "react";
import { StoreContext } from "./context";
import { State } from "./type";
import reducer from "./reducer";

const StoreProvider: React.FC<{ value: State; children: ReactNode }> = ({ value, children }) => {
  const [state, dispatch] = useReducer(reducer, value);

  useEffect(() => {
    dispatch({ type: "INIT_STATE", payload: value });
  }, [value]);

  return <StoreContext.Provider value={{ state, dispatch }}>{children}</StoreContext.Provider>;
};

export default StoreProvider;
